<template>
  <div class="p-field p-col-6 p-lg-2">
    <AppFormItem label="Criar registro no caixa">
      <div>
        <InputSwitch
          :modelValue="createTransaction"
          @update:modelValue="$emit('update:createTransaction', $event)"
        ></InputSwitch>
      </div>
    </AppFormItem>
  </div>
  <div class="p-field p-col-6 p-lg-2">
    <AppFormItem label="Tipo de lançamento">
      <AppAutoComplete
        valueField="id"
        :options="cashFlowTypes"
        :modelValue="transactionType"
        @update:modelValue="$emit('update:transactionType', $event)"
      ></AppAutoComplete>
    </AppFormItem>
  </div>
</template>

<script>
export default {
  name: 'ServiceEditTransaction',
  props: {
    createTransaction: Boolean,
    transactionType: Number,
  },
  data() {
    return {
      cashFlowTypes: [
        { id: 1, name: 'Receita' },
        { id: 2, name: 'Despesa' },
      ],
    };
  },
};
</script>

<style>
</style>